var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"newsletters-signup"},[_c('AppImage',{staticClass:"newsletters-signup__image",attrs:{"image-src":_vm.pictures,"preview-src":require('~/assets/images/newsletters-signup/newsletters-signup-bg-preview.webp')}}),_vm._v(" "),_c('NewslettersSignup',{staticClass:"newsletters-signup__form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }